import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkOrderState } from '@app/core/store/reducers/work-order';

const geWorkOrderFeatureState = createFeatureSelector<WorkOrderState>('workOrder');

export const getCurrentWorkOrder = createSelector(
  geWorkOrderFeatureState,
  (state: WorkOrderState) => state.currentWorkOrder,
);

export const getHierarchy = createSelector(geWorkOrderFeatureState, (state: WorkOrderState) => state.hierarchy);

export const getSelectedWorkLines = createSelector(
  geWorkOrderFeatureState,
  (state: WorkOrderState) => state.selectedWorkLines,
);

export const getSelectedObjects = createSelector(
  geWorkOrderFeatureState,
  (state: WorkOrderState) => state.selectedObjects,
);

export const getActiveMarkupDocumentId = createSelector(
  geWorkOrderFeatureState,
  (state: WorkOrderState) => state.activeMarkupDocumentId,
);
